<template>
  <v-container class="app-container">
  <div class="request-view">
    <!-- Formular-Auswahl Tabs -->
    <v-card class="request-card mb-4">
      <div class="card-tabs">
        <v-tabs v-model="activeRequestTab" color="success" align-tabs="start">
          <v-tab value="standard" class="tab-item">
            <v-icon start>mdi-clipboard-list</v-icon>
            Standard-Anfrage
          </v-tab>
          <v-tab value="simple" class="tab-item">
            <v-icon start>mdi-clipboard-outline</v-icon>
            Schnellanfrage
          </v-tab>
        </v-tabs>
      </div>

      <v-window v-model="activeRequestTab">
        <!-- Standard Anfrage (mit mehreren Ersatzteilen) -->
        <v-window-item value="standard">
          <div class="card-header">
            <div class="title-container">
              <v-icon color="primary" size="24" class="mr-2"
                >mdi-clipboard-list</v-icon
              >
              <h2 class="card-title">Standard Ersatzteil-Anfrage</h2>
            </div>
          </div>

          <v-divider class="card-divider"></v-divider>

          <div class="card-content">
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Datum/Uhrzeit"
                  v-model="currentDateTime"
                  readonly
                  variant="outlined"
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small"
                      >mdi-calendar-clock</v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="advancedRequest.orderNumber"
                  label="Auftragsnummer"
                  variant="outlined"
                  placeholder="7-10 stellige Nummer"
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                  hint="Bitte geben Sie eine 7-10 stellige Zahl ein"
                  :error-messages="
                    !advancedRequest.orderNumber ||
                    isValidOrderNumber(advancedRequest.orderNumber.trim())
                      ? undefined
                      : 'Die Auftragsnummer muss zwischen 7 und 10 Stellen lang sein und darf nur Zahlen enthalten'
                  "
                  required
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small">mdi-identifier</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <!-- Ersatzteilliste -->
            <div class="parts-list">
              <h3 class="parts-title">
                <v-icon color="success" size="small" class="mr-1"
                  >mdi-format-list-bulleted</v-icon
                >
                Ersatzteile
              </h3>

              <div
                v-for="(item, index) in advancedRequest.items"
                :key="index"
                class="part-item"
              >
                <div class="part-header">
                  <span class="part-number">Ersatzteil #{{ index + 1 }}</span>
                  <v-btn
                    v-if="advancedRequest.items.length > 1"
                    icon
                    variant="text"
                    color="error"
                    size="small"
                    @click="removePartItem(index)"
                    class="action-btn"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>

                <v-row>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="item.ersatzteil"
                      label="Ersatzteil"
                      variant="outlined"
                      placeholder="Bezeichnung eingeben"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                      required
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small">mdi-cog</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="item.lagerort"
                      label="Lagerort"
                      variant="outlined"
                      placeholder="Lagerort angeben"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                      required
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small"
                          >mdi-map-marker</v-icon
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="item.stueckzahl"
                      label="Menge"
                      type="number"
                      variant="outlined"
                      placeholder="Stückzahl"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                      min="1"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small"
                          >mdi-numeric</v-icon
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.sonstiges"
                      label="Anmerkung Monteur"
                      variant="outlined"
                      placeholder="Zusatzinformationen (optional)"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small"
                          >mdi-text-box-outline</v-icon
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-divider
                  v-if="index < advancedRequest.items.length - 1"
                  class="item-divider"
                ></v-divider>
              </div>

              <div class="add-part-actions">
                <v-btn
                  color="success"
                  variant="tonal"
                  @click="addPartItem"
                  size="small"
                  class="add-part-btn"
                >
                  <v-icon start>mdi-plus</v-icon>
                  Weiteres Ersatzteil hinzufügen
                </v-btn>
              </div>
            </div>
          </div>

          <v-divider class="card-divider"></v-divider>

          <div class="card-actions">
            <v-btn
              color="success"
              variant="elevated"
              class="submit-btn"
              @click="submitAdvancedRequest"
              :loading="submitting"
              :disabled="!isAdvancedFormValid"
            >
              <v-icon start>mdi-send</v-icon>
              Anfrage senden
            </v-btn>
          </div>
        </v-window-item>

        <!-- Einfache Anfrage (einzelnes Ersatzteil) -->
        <v-window-item value="simple">
          <div class="card-header">
            <div class="title-container">
              <v-icon color="primary" size="24" class="mr-2"
                >mdi-basket-plus</v-icon
              >
              <h2 class="card-title">Schnell-Anfrage</h2>
            </div>
          </div>

          <v-divider class="card-divider"></v-divider>

          <div class="card-content">
            <v-row>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Datum/Uhrzeit"
                  v-model="currentDateTime"
                  readonly
                  variant="outlined"
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small"
                      >mdi-calendar-clock</v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  v-model="ersatzteil"
                  label="Ersatzteil"
                  variant="outlined"
                  placeholder="Bezeichnung eingeben"
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                  required
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small">mdi-cog</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Lagerort"
                  v-model="lagerort"
                  variant="outlined"
                  placeholder="Lagerort angeben"
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                  required
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small">mdi-map-marker</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Menge"
                  v-model="stueckzahl"
                  type="number"
                  variant="outlined"
                  placeholder="Stückzahl"
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                  min="1"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small">mdi-numeric</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Anmerkung Monteur"
                  v-model="sonstiges"
                  variant="outlined"
                  placeholder="Zusatzinformationen (optional)"
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small"
                      >mdi-text-box-outline</v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-divider class="card-divider"></v-divider>

          <div class="card-actions">
            <v-btn
              color="success"
              variant="elevated"
              class="submit-btn"
              @click="submitRequest"
              :loading="submitting"
              :disabled="!isFormValid"
            >
              <v-icon start>mdi-send</v-icon>
              Anfrage senden
            </v-btn>
          </div>
        </v-window-item>
      </v-window>
    </v-card>

    <!-- Offene Aufträge (zur Bearbeitung) -->
    <v-card class="request-card mb-6" v-if="openOrders.length > 0">
      <div class="card-header active-header">
        <div class="title-container">
          <v-icon color="amber" size="24" class="mr-2"
            >mdi-clock-outline</v-icon
          >
          <h2 class="card-title">Eigene Anfragen (offen)</h2>
        </div>

        <div class="header-actions">
          <v-chip variant="elevated" color="amber" class="status-counter">
            {{ openOrders.length }}
          </v-chip>
        </div>
      </div>

      <v-divider class="card-divider"></v-divider>

      <!-- Auftragsanzeige für Desktop -->
      <div class="order-list" v-if="!isMobile">
        <div
          v-for="order in openOrders"
          :key="order.id"
          class="order-container"
        >
          <div class="order-header" @click="toggleOrderExpand(order.id)">
            <div class="order-info">
              <div class="order-number">
                <v-icon color="success" size="small" class="mr-1"
                  >mdi-identifier</v-icon
                >
                <span class="order-id">{{
                  order.order_number || `Auftrag #${order.id}`
                }}</span>
                <v-chip
                  v-if="order.items.length > 1"
                  size="x-small"
                  color="success"
                  class="ml-2 position-counter"
                >
                  {{ order.items.length }} Teile
                </v-chip>
              </div>
              <div class="order-date">
                <v-icon color="success" size="small" class="mr-1"
                  >mdi-calendar-clock</v-icon
                >
                {{ formatDate(new Date(order.request_datetime)) }}
              </div>

              <!-- Status-Übersicht hinzufügen -->
              <div class="status-overview mt-1">
                <div class="status-pills">
                  <v-chip
                    v-if="getStatusCount(order, 'offen') > 0"
                    size="x-small"
                    color="info"
                    class="status-pill mr-1"
                  >
                    {{ getStatusCount(order, "offen") }} offen
                  </v-chip>
                  <v-chip
                    v-if="getStatusCount(order, 'wartend') > 0"
                    size="x-small"
                    color="amber"
                    class="status-pill mr-1"
                  >
                    {{ getStatusCount(order, "wartend") }} wartend
                  </v-chip>
                  <v-chip
                    v-if="getStatusCount(order, 'erledigt') > 0"
                    size="x-small"
                    color="success"
                    class="status-pill mr-1"
                  >
                    {{ getStatusCount(order, "erledigt") }} erledigt
                  </v-chip>
                  <v-chip
                    v-if="getStatusCount(order, 'nicht vorhanden') > 0"
                    size="x-small"
                    color="error"
                    class="status-pill"
                  >
                    {{ getStatusCount(order, "nicht vorhanden") }} n.v.
                  </v-chip>
                </div>
              </div>
              <!-- Anmerkungsanzeige hinzufügen -->
              <div v-if="hasComments(order)" class="comments-indicator mt-1">
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <span v-bind="props" class="comment-pill">
                      <v-icon size="x-small" color="amber" class="mr-1"
                        >mdi-comment-text-outline</v-icon
                      >
                      {{ countComments(order) }} Anmerkung{{
                        countComments(order) > 1 ? "en" : ""
                      }}
                    </span>
                  </template>
                  <div class="tooltip-content">
                    <div
                      v-for="(item, idx) in getItemsWithComments(order)"
                      :key="idx"
                      class="tooltip-comment"
                    >
                      <strong>{{ item.ersatzteil }}:</strong>
                      {{ shortenText(item.commission_comment, 80) }}
                    </div>
                  </div>
                </v-tooltip>
              </div>
            </div>

            <div class="order-status">
              <v-chip
                size="small"
                :color="getStatusColor(order.status)"
                class="status-chip mr-2"
              >
                {{ order.status }}
              </v-chip>

              <div class="action-buttons">
                <v-btn
                  icon
                  variant="text"
                  color="success"
                  size="small"
                  class="action-btn"
                  @click.stop="editOrder(order)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  icon
                  variant="text"
                  color="error"
                  size="small"
                  class="action-btn"
                  @click.stop="confirmDeleteOrder(order.id)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>

              <v-icon
                :class="expandedOrders.has(order.id) ? 'rotate-icon' : ''"
                class="expand-icon"
              >
                mdi-chevron-down
              </v-icon>
            </div>
          </div>

          <!-- Ersatzteilliste für den Auftrag -->
          <div
            v-if="expandedOrders.has(order.id)"
            class="order-items-container"
          >
            <table class="items-table">
              <thead>
                <tr>
                  <th>Ersatzteil</th>
                  <th>Lagerort</th>
                  <th>Menge</th>
                  <th>Anmerkung Monteur</th>
                  <th>Anmerkung Lager</th>
                  <th>Status</th>
                  <th class="actions-column">Aktionen</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in order.items"
                  :key="item.id"
                  :class="rowClass(item.status)"
                >
                  <td>{{ item.ersatzteil }}</td>
                  <td>{{ item.lagerort }}</td>
                  <td>{{ item.stueckzahl }}</td>
                  <td>
                    <v-tooltip location="bottom">
                      <template v-slot:activator="{ props }">
                        <span v-bind="props" class="truncate-text">
                          {{ shortenText(item.sonstiges) }}
                        </span>
                      </template>
                      <span>{{ item.sonstiges }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <v-tooltip location="bottom">
                      <template v-slot:activator="{ props }">
                        <span v-bind="props" class="truncate-text">
                          {{
                            item.commission_comment
                              ? shortenText(item.commission_comment)
                              : ""
                          }}
                        </span>
                      </template>
                      <span>{{ item.commission_comment }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <v-chip
                      size="x-small"
                      :color="getStatusColor(item.status)"
                      class="status-chip"
                    >
                      {{ item.status }}
                    </v-chip>
                  </td>
                  <td class="actions-column">
                    <div class="action-buttons">
                      <v-btn
                        icon
                        variant="text"
                        color="success"
                        size="x-small"
                        class="action-btn"
                        @click="editItem(item, order)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Mobile-Ansicht für Aufträge -->
      <div class="mobile-orders" v-else>
        <div
          v-for="order in openOrders"
          :key="order.id"
          class="order-card-mobile"
          :class="rowClass(order.status)"
        >
          <div class="order-card-header" @click="toggleOrderExpand(order.id)">
            <div class="order-mobile-info">
              <div class="order-id-mobile">
                {{ order.order_number || `Auftrag #${order.id}` }}
                <v-chip
                  v-if="order.items.length > 1"
                  size="x-small"
                  density="compact"
                  color="success"
                  class="ml-1 position-counter-mobile"
                >
                  {{ order.items.length }}
                </v-chip>
              </div>

              <!-- Status-Übersicht für Mobile hinzufügen -->
              <div class="status-overview-mobile">
                <v-chip
                  v-if="getStatusCount(order, 'offen') > 0"
                  density="compact"
                  size="x-small"
                  color="info"
                  class="status-pill-mobile mr-1"
                >
                  {{ getStatusCount(order, "offen") }}
                </v-chip>
                <v-chip
                  v-if="getStatusCount(order, 'wartend') > 0"
                  density="compact"
                  size="x-small"
                  color="amber"
                  class="status-pill-mobile mr-1"
                >
                  {{ getStatusCount(order, "wartend") }}
                </v-chip>
                <v-chip
                  v-if="getStatusCount(order, 'erledigt') > 0"
                  density="compact"
                  size="x-small"
                  color="success"
                  class="status-pill-mobile mr-1"
                >
                  {{ getStatusCount(order, "erledigt") }}
                </v-chip>
                <v-chip
                  v-if="getStatusCount(order, 'nicht vorhanden') > 0"
                  density="compact"
                  size="x-small"
                  color="error"
                  class="status-pill-mobile"
                >
                  {{ getStatusCount(order, "nicht vorhanden") }}
                </v-chip>
              </div>
              <div v-if="hasComments(order)" class="comments-indicator-mobile">
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-chip
                      v-bind="props"
                      density="compact"
                      size="x-small"
                      color="amber"
                      class="comment-pill-mobile"
                    >
                      <v-icon size="x-small" class="mr-1"
                        >mdi-comment-text-outline</v-icon
                      >
                      {{ countComments(order) }}
                    </v-chip>
                  </template>
                  <div class="tooltip-content">
                    <div
                      v-for="(item, idx) in getItemsWithComments(order)"
                      :key="idx"
                      class="tooltip-comment"
                    >
                      <strong>{{ item.ersatzteil }}:</strong>
                      {{ shortenText(item.commission_comment, 50) }}
                    </div>
                  </div>
                </v-tooltip>
              </div>
            </div>

            <div class="order-status-mobile">
              <v-chip
                size="x-small"
                :color="getStatusColor(order.status)"
                class="status-chip-mobile"
              >
                {{ order.status }}
              </v-chip>

              <v-icon
                :class="expandedOrders.has(order.id) ? 'rotate-icon' : ''"
                class="expand-icon-mobile"
                size="small"
              >
                mdi-chevron-down
              </v-icon>
            </div>
          </div>

          <!-- Ersatzteilliste (Mobile) -->
          <div v-if="expandedOrders.has(order.id)" class="order-items-mobile">
            <div
              v-for="item in order.items"
              :key="item.id"
              class="item-card-mobile"
              :class="rowClass(item.status)"
            >
              <div class="item-card-content">
                <div class="item-info-row">
                  <v-icon size="x-small" color="success">mdi-cog</v-icon>
                  <span class="info-label">Ersatzteil:</span>
                  <span class="info-value">{{ item.ersatzteil }}</span>
                </div>

                <div class="item-info-row">
                  <v-icon size="x-small" color="success">mdi-map-marker</v-icon>
                  <span class="info-label">Lagerort:</span>
                  <span class="info-value">{{ item.lagerort }}</span>
                </div>

                <div class="item-info-row">
                  <v-icon size="x-small" color="success">mdi-numeric</v-icon>
                  <span class="info-label">Menge:</span>
                  <span class="info-value">{{ item.stueckzahl }}</span>
                </div>

                <div class="item-info-row" v-if="item.sonstiges">
                  <v-icon size="x-small" color="success"
                    >mdi-text-box-outline</v-icon
                  >
                  <span class="info-label">Anmerkung:</span>
                  <span class="info-value">{{ item.sonstiges }}</span>
                </div>

                <div class="item-info-row" v-if="item.commission_comment">
                  <v-icon size="x-small" color="amber"
                    >mdi-comment-text-outline</v-icon
                  >
                  <span class="info-label">Lager:</span>
                  <span class="info-value">{{ item.commission_comment }}</span>
                </div>

                <div class="item-status-row">
                  <v-chip
                    size="x-small"
                    :color="getStatusColor(item.status)"
                    class="status-chip-mobile"
                  >
                    {{ item.status }}
                  </v-chip>

                  <v-btn
                    variant="text"
                    color="success"
                    size="x-small"
                    class="action-btn-mobile"
                    @click="editItem(item, order)"
                  >
                    <v-icon start size="x-small">mdi-pencil</v-icon>
                    Bearbeiten
                  </v-btn>
                </div>
              </div>
            </div>

            <div class="order-actions-mobile">
              <v-btn
                variant="text"
                color="success"
                size="small"
                class="action-btn-mobile"
                @click="editOrder(order)"
              >
                <v-icon start size="small">mdi-pencil</v-icon>
                Auftrag bearbeiten
              </v-btn>
              <v-btn
                variant="text"
                color="error"
                size="small"
                class="action-btn-mobile"
                @click="confirmDeleteOrder(order.id)"
              >
                <v-icon start size="small">mdi-delete</v-icon>
                Auftrag löschen
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Erledigte Aufträge -->
    <v-card class="request-card mb-6" v-if="doneOrders.length > 0">
      <div class="card-header completed-header">
        <div class="title-container">
          <v-icon color="success" size="24" class="mr-2"
            >mdi-check-circle</v-icon
          >
          <h2 class="card-title">Erledigte Anfragen</h2>
        </div>

        <div class="header-actions">
          <v-chip variant="elevated" color="success" class="status-counter">
            {{ totalDoneOrders }}
          </v-chip>
        </div>
      </div>

      <v-divider class="card-divider"></v-divider>

      <!-- Desktop Ansicht für erledigte Aufträge -->
      <div class="order-list" v-if="!isMobile">
        <div
          v-for="order in doneOrders"
          :key="order.id"
          class="order-container"
        >
          <div class="order-header" @click="toggleOrderExpand(order.id)">
            <div class="order-info">
              <div class="order-number">
                <v-icon color="success" size="small" class="mr-1"
                  >mdi-identifier</v-icon
                >
                <span class="order-id">{{
                  order.order_number || `Auftrag #${order.id}`
                }}</span>
              </div>
              <div class="order-date">
                <v-icon color="success" size="small" class="mr-1"
                  >mdi-calendar-clock</v-icon
                >
                {{ formatDate(new Date(order.request_datetime)) }}
              </div>
            </div>

            <div class="order-status">
              <v-chip
                size="small"
                :color="getStatusColor(order.status)"
                class="status-chip mr-2"
              >
                {{ order.status }}
              </v-chip>

              <v-icon
                :class="expandedOrders.has(order.id) ? 'rotate-icon' : ''"
                class="expand-icon"
              >
                mdi-chevron-down
              </v-icon>
            </div>
          </div>

          <!-- Ersatzteilliste für den erledigten Auftrag -->
          <div
            v-if="expandedOrders.has(order.id)"
            class="order-items-container"
          >
            <table class="items-table">
              <thead>
                <tr>
                  <th>Ersatzteil</th>
                  <th>Lagerort</th>
                  <th>Menge</th>
                  <th>Anmerkung Monteur</th>
                  <th>Anmerkung Lager</th>
                  <th>Status</th>
                  <th>Bearbeitungsende</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in order.items"
                  :key="item.id"
                  :class="rowClass(item.status)"
                >
                  <td>{{ item.ersatzteil }}</td>
                  <td>{{ item.lagerort }}</td>
                  <td>{{ item.stueckzahl }}</td>
                  <td>
                    <v-tooltip location="bottom">
                      <template v-slot:activator="{ props }">
                        <span v-bind="props" class="truncate-text">
                          {{ shortenText(item.sonstiges) }}
                        </span>
                      </template>
                      <span>{{ item.sonstiges }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <v-tooltip location="bottom">
                      <template v-slot:activator="{ props }">
                        <span v-bind="props" class="truncate-text">
                          {{
                            item.commission_comment
                              ? shortenText(item.commission_comment)
                              : ""
                          }}
                        </span>
                      </template>
                      <span>{{ item.commission_comment }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <v-chip
                      size="x-small"
                      :color="getStatusColor(item.status)"
                      class="status-chip"
                    >
                      {{ item.status }}
                    </v-chip>
                  </td>
                  <td>
                    {{
                      item.ended_at ? formatDate(new Date(item.ended_at)) : "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          v-if="totalDoneOrders > doneOrders.length"
          class="show-all-container"
        >
          <v-btn
            color="success"
            variant="tonal"
            size="small"
            class="show-more-btn"
            @click="loadMoreDoneOrders"
            :loading="loadingMoreOrders"
          >
            <v-icon start>mdi-plus</v-icon>
            10 weitere Aufträge laden
          </v-btn>
          <div class="text-caption mt-1">
            {{ totalDoneOrders - doneOrders.length }} weitere erledigte Anfragen
            sind verfügbar
          </div>
        </div>

        <!-- Wenn mehr als die Standardmenge geladen wurde -->
        <div v-if="doneOrdersPage > 1" class="show-less-container">
          <v-btn
            color="grey"
            variant="text"
            size="small"
            class="show-less-btn"
            @click="resetDoneOrders"
          >
            <v-icon start>mdi-arrow-collapse-up</v-icon>
            Weniger anzeigen
          </v-btn>
        </div>

        <!-- "Alle anzeigen" Button behalten wir auch -->
        <div
          v-if="
            totalDoneOrders > defaultDoneOrdersLimit && doneOrdersPage === 1
          "
          class="show-all-container"
        >
          <v-btn
            color="success"
            variant="outlined"
            size="small"
            class="show-all-btn"
            @click="loadAllDoneOrders"
            :loading="loadingMoreOrders"
          >
            <v-icon start>mdi-eye</v-icon>
            Alle {{ totalDoneOrders }} erledigten Aufträge anzeigen
          </v-btn>
        </div>
      </div>

      <!-- Mobile Ansicht für erledigte Aufträge -->
      <div class="mobile-orders" v-else>
        <div
          v-for="order in doneOrders"
          :key="order.id"
          class="order-card-mobile completed"
        >
          <div class="order-card-header" @click="toggleOrderExpand(order.id)">
            <div class="order-mobile-info">
              <div class="order-id-mobile">
                {{ order.order_number || `Auftrag #${order.id}` }}
              </div>
              <div class="order-date-mobile">
                <v-icon size="x-small" color="success" class="mr-1"
                  >mdi-calendar-clock</v-icon
                >
                {{ formatDate(new Date(order.request_datetime)) }}
              </div>
            </div>

            <div class="order-status-mobile">
              <v-chip
                size="x-small"
                :color="getStatusColor(order.status)"
                class="status-chip-mobile"
              >
                {{ order.status }}
              </v-chip>

              <v-icon
                :class="expandedOrders.has(order.id) ? 'rotate-icon' : ''"
                class="expand-icon-mobile"
                size="small"
              >
                mdi-chevron-down
              </v-icon>
            </div>
          </div>

          <!-- Mobile Ersatzteilliste -->
          <div v-if="expandedOrders.has(order.id)" class="order-items-mobile">
            <div
              v-for="item in order.items"
              :key="item.id"
              class="item-card-mobile"
              :class="rowClass(item.status)"
            >
              <div class="item-card-content">
                <div class="item-info-row">
                  <v-icon size="x-small" color="success">mdi-cog</v-icon>
                  <span class="info-label">Ersatzteil:</span>
                  <span class="info-value">{{ item.ersatzteil }}</span>
                </div>

                <div class="item-info-row">
                  <v-icon size="x-small" color="success">mdi-map-marker</v-icon>
                  <span class="info-label">Lagerort:</span>
                  <span class="info-value">{{ item.lagerort }}</span>
                </div>

                <div class="item-info-row">
                  <v-icon size="x-small" color="success">mdi-numeric</v-icon>
                  <span class="info-label">Menge:</span>
                  <span class="info-value">{{ item.stueckzahl }}</span>
                </div>

                <div class="item-info-row" v-if="item.sonstiges">
                  <v-icon size="x-small" color="success"
                    >mdi-text-box-outline</v-icon
                  >
                  <span class="info-label">Anmerkung:</span>
                  <span class="info-value">{{
                    shortenText(item.sonstiges)
                  }}</span>
                </div>

                <div class="item-info-row" v-if="item.commission_comment">
                  <v-icon size="x-small" color="amber"
                    >mdi-comment-text-outline</v-icon
                  >
                  <span class="info-label">Lager:</span>
                  <span class="info-value">{{
                    shortenText(item.commission_comment)
                  }}</span>
                </div>

                <div class="item-info-row">
                  <v-icon size="x-small" color="success"
                    >mdi-calendar-check</v-icon
                  >
                  <span class="info-label">Erledigt am:</span>
                  <span class="info-value">{{
                    item.ended_at ? formatDate(new Date(item.ended_at)) : "-"
                  }}</span>
                </div>

                <div class="item-status-row">
                  <v-chip
                    size="x-small"
                    :color="getStatusColor(item.status)"
                    class="status-chip-mobile"
                  >
                    {{ item.status }}
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="totalDoneOrders > doneOrders.length"
          class="show-all-container"
        >
          <v-btn
            color="success"
            variant="tonal"
            size="small"
            class="show-more-btn"
            @click="loadMoreDoneOrders"
            :loading="loadingMoreOrders"
          >
            <v-icon start>mdi-plus</v-icon>
            10 weitere Aufträge laden
          </v-btn>
          <div class="text-caption mt-1">
            {{ totalDoneOrders - doneOrders.length }} weitere erledigte Anfragen
            sind verfügbar
          </div>
        </div>

        <!-- Wenn mehr als die Standardmenge geladen wurde -->
        <div v-if="doneOrdersPage > 1" class="show-less-container">
          <v-btn
            color="grey"
            variant="text"
            size="small"
            class="show-less-btn"
            @click="resetDoneOrders"
          >
            <v-icon start>mdi-arrow-collapse-up</v-icon>
            Weniger anzeigen
          </v-btn>
        </div>

        <!-- "Alle anzeigen" Button behalten wir auch -->
        <div
          v-if="
            totalDoneOrders > defaultDoneOrdersLimit && doneOrdersPage === 1
          "
          class="show-all-container"
        >
          <v-btn
            color="success"
            variant="outlined"
            size="small"
            class="show-all-btn"
            @click="loadAllDoneOrders"
            :loading="loadingMoreOrders"
          >
            <v-icon start>mdi-eye</v-icon>
            Alle {{ totalDoneOrders }} erledigten Aufträge anzeigen
          </v-btn>
        </div>
      </div></v-card
    >

    <!-- Bearbeitungsdialog für Ersatzteile -->
    <v-dialog v-model="editItemDialog" max-width="600px" class="request-dialog">
      <v-card class="dialog-card">
        <v-card-title class="dialog-header">
          <v-icon color="success" size="24" class="mr-2">mdi-pencil</v-icon>
          <span>Ersatzteil bearbeiten</span>
        </v-card-title>
        <v-divider class="dialog-divider"></v-divider>
        <v-card-text class="dialog-content">
          <v-form ref="itemForm">
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="Ersatzteil"
                  v-model="itemToEdit.ersatzteil"
                  variant="outlined"
                  required
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small">mdi-cog</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="Lagerort"
                  v-model="itemToEdit.lagerort"
                  variant="outlined"
                  required
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small">mdi-map-marker</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="Menge"
                  v-model="itemToEdit.stueckzahl"
                  type="number"
                  variant="outlined"
                  min="1"
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small">mdi-numeric</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Anmerkung Monteur"
                  v-model="itemToEdit.sonstiges"
                  variant="outlined"
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hide-details="auto"
                  class="form-field"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small"
                      >mdi-text-box-outline</v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider class="dialog-divider"></v-divider>
        <v-card-actions class="dialog-actions">
          <v-btn variant="text" color="grey" @click="editItemDialog = false">
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            variant="elevated"
            @click="updateItem"
            :loading="updating"
            :disabled="!isEditItemFormValid"
          >
            <v-icon start>mdi-content-save</v-icon>
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Bearbeitungsdialog für Aufträge -->
    <v-dialog
      v-model="editOrderDialog"
      max-width="900px"
      class="request-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header">
          <v-icon color="success" size="24" class="mr-2"
            >mdi-clipboard-edit</v-icon
          >
          <span>Auftrag bearbeiten</span>
        </v-card-title>
        <v-divider class="dialog-divider"></v-divider>
        <v-card-text class="dialog-content">
          <v-form ref="orderForm">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Auftragsnummer"
                  v-model="orderToEdit.order_number"
                  variant="outlined"
                  placeholder="7-10 stellige Nummer"
                  bg-color="rgba(30, 30, 40, 0.5)"
                  hint="Bitte geben Sie eine 7-10 stellige Zahl ein"
                  :error-messages="
                    !orderToEdit.order_number ||
                    isValidOrderNumber(orderToEdit.order_number.trim())
                      ? undefined
                      : 'Die Auftragsnummer muss zwischen 7 und 10 Stellen lang sein und darf nur Zahlen enthalten'
                  "
                  hide-details="auto"
                  class="mb-4 form-field"
                  required
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="success" size="small">mdi-identifier</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <!-- Ersatzteilliste -->
            <div class="edit-parts-list">
              <div class="parts-title-bar">
                <h3 class="parts-title">
                  <v-icon color="success" size="small" class="mr-1"
                    >mdi-format-list-bulleted</v-icon
                  >
                  Ersatzteile
                </h3>
              </div>

              <div
                v-for="(item, index) in orderToEdit.items"
                :key="index"
                class="edit-part-item"
              >
                <div class="part-header">
                  <span class="part-number">Ersatzteil #{{ index + 1 }}</span>
                  <v-btn
                    v-if="orderToEdit.items.length > 1"
                    icon
                    variant="text"
                    color="error"
                    size="small"
                    @click="removeOrderPartItem(index)"
                    class="action-btn"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>

                <v-row>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="item.ersatzteil"
                      label="Ersatzteil"
                      variant="outlined"
                      placeholder="Bezeichnung eingeben"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                      required
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small">mdi-cog</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="item.lagerort"
                      label="Lagerort"
                      variant="outlined"
                      placeholder="Lagerort angeben"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                      required
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small"
                          >mdi-map-marker</v-icon
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="item.stueckzahl"
                      label="Menge"
                      type="number"
                      variant="outlined"
                      placeholder="Stückzahl"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                      min="1"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small"
                          >mdi-numeric</v-icon
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.sonstiges"
                      label="Anmerkung Monteur"
                      variant="outlined"
                      placeholder="Zusatzinformationen (optional)"
                      bg-color="rgba(30, 30, 40, 0.5)"
                      hide-details="auto"
                      class="form-field"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="small"
                          >mdi-text-box-outline</v-icon
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-divider
                  v-if="index < orderToEdit.items.length - 1"
                  class="item-divider"
                ></v-divider>
              </div>

              <div class="add-part-actions">
                <v-btn
                  color="success"
                  variant="tonal"
                  @click="addOrderPartItem"
                  size="small"
                  class="add-part-btn"
                >
                  <v-icon start>mdi-plus</v-icon>
                  Weiteres Ersatzteil hinzufügen
                </v-btn>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-divider class="dialog-divider"></v-divider>
        <v-card-actions class="dialog-actions">
          <v-btn variant="text" color="grey" @click="editOrderDialog = false">
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            variant="elevated"
            @click="updateOrder"
            :loading="updating"
            :disabled="!isEditOrderFormValid"
          >
            <v-icon start>mdi-content-save</v-icon>
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Lösch-Dialog für Aufträge -->
    <v-dialog
      v-model="deleteOrderDialog"
      max-width="400px"
      class="confirm-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header error-header">
          <v-icon color="error" size="24" class="mr-2">mdi-alert-circle</v-icon>
          <span>Auftrag löschen?</span>
        </v-card-title>
        <v-divider class="dialog-divider"></v-divider>
        <v-card-text class="dialog-content pt-4">
          Möchtest du diesen Auftrag mit allen zugehörigen Ersatzteilen wirklich
          löschen? Diese Aktion kann nicht rückgängig gemacht werden.
        </v-card-text>
        <v-divider class="dialog-divider"></v-divider>
        <v-card-actions class="dialog-actions">
          <v-btn variant="text" color="grey" @click="deleteOrderDialog = false">
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            variant="elevated"
            @click="deleteOrder"
            :loading="deleting"
          >
            <v-icon start>mdi-delete</v-icon>
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</v-container>
</template>

<script setup>
import { ref, onMounted, computed, onBeforeUnmount, nextTick } from "vue";
import axios from "axios";
import { API_BASE_URL, WS_URL } from "../config";
import { useToast } from "vue-toastification";
import { useDisplay } from "vuetify";

// ======== Basis-Setup ========
const toast = useToast();
const { mobile, mdAndDown } = useDisplay();
const isMobile = computed(() => mobile.value || mdAndDown.value);
const showAllDoneOrders = ref(false);
const loadingAllOrders = ref(false);
const defaultDoneOrdersLimit = 10;
const doneOrdersPage = ref(1);
const loadingMoreOrders = ref(false);

// ======== Tab-Verwaltung ========
const activeRequestTab = ref("standard"); // Default ist die Standard-Anfrage

// ======== Formularfelder ========
const currentDateTime = ref(formatDate(new Date()));
// Einfache Anfrage Felder
const ersatzteil = ref("");
const lagerort = ref("");
const stueckzahl = ref("1");
const sonstiges = ref("");
// Erweiterte Anfrage Felder
const advancedRequest = ref({
  orderNumber: "",
  items: [
    {
      ersatzteil: "",
      lagerort: "",
      stueckzahl: "1",
      sonstiges: "",
    },
  ],
});

// Aufteilung in offene und erledigte Aufträge
const totalDoneOrders = computed(
  () =>
    requests.value.filter((r) => r.status.toLowerCase() === "erledigt").length
);

// ======== Status-Variablen ========
const submitting = ref(false);
const updating = ref(false);
const deleting = ref(false);

// ======== Dialog- und Bearbeitungszustände ========
const expandedOrders = ref(new Set());
const editItemDialog = ref(false);
const editOrderDialog = ref(false);
const deleteOrderDialog = ref(false);
const itemToEdit = ref({});
const orderToEdit = ref({ items: [] });
const orderToDeleteId = ref(null);
const parentOrderOfItem = ref(null);

// ======== Datenquellen ========
const requests = ref([]);

// ======== Berechnete Eigenschaften ========
// Validierung für einfache Anfrage
const isFormValid = computed(
  () =>
    ersatzteil.value.trim() !== "" &&
    lagerort.value.trim() !== "" &&
    stueckzahl.value &&
    parseInt(stueckzahl.value) > 0
);

// Validierung für erweiterte Anfrage
const isAdvancedFormValid = computed(() => {
  // Prüfe, ob die Auftragsnummer valide ist (7-10 Stellen, nur Zahlen)
  if (!isValidOrderNumber(advancedRequest.value.orderNumber.trim()))
    return false;

  return advancedRequest.value.items.every(
    (item) =>
      item.ersatzteil.trim() !== "" &&
      item.lagerort.trim() !== "" &&
      item.stueckzahl &&
      parseInt(item.stueckzahl) > 0
  );
});

// Validierung für die Bearbeitung eines einzelnen Ersatzteils
const isEditItemFormValid = computed(
  () =>
    itemToEdit.value?.ersatzteil?.trim() !== "" &&
    itemToEdit.value?.lagerort?.trim() !== "" &&
    itemToEdit.value?.stueckzahl &&
    parseInt(itemToEdit.value?.stueckzahl) > 0
);

// Validierung für die Bearbeitung eines Auftrags
const isEditOrderFormValid = computed(() => {
  if (!orderToEdit.value || !orderToEdit.value.order_number) return false;

  // Prüfe, ob die Auftragsnummer valide ist (7-10 Stellen, nur Zahlen)
  if (!isValidOrderNumber(orderToEdit.value.order_number.trim())) return false;

  return (
    orderToEdit.value.items &&
    orderToEdit.value.items.every(
      (item) =>
        item.ersatzteil?.trim() !== "" &&
        item.lagerort?.trim() !== "" &&
        item.stueckzahl &&
        parseInt(item.stueckzahl) > 0
    )
  );
});

// Aufteilung in offene und erledigte Aufträge
const openOrders = computed(() =>
  requests.value
    .filter((r) => r.status.toLowerCase() !== "erledigt")
    .sort((a, b) => new Date(b.request_datetime) - new Date(a.request_datetime))
);

const doneOrders = computed(() => {
  // Filter und sortiere wie zuvor
  const filteredOrders = requests.value
    .filter((r) => r.status.toLowerCase() === "erledigt")
    .sort(
      (a, b) => new Date(b.request_datetime) - new Date(a.request_datetime)
    );

  // Wenn "Alle anzeigen" aktiviert ist, zeige alle an,
  // ansonsten nur die ersten X Aufträge basierend auf der aktuellen Seite
  return showAllDoneOrders.value
    ? filteredOrders
    : filteredOrders.slice(0, doneOrdersPage.value * defaultDoneOrdersLimit);
});

const loadMoreDoneOrders = async () => {
  loadingMoreOrders.value = true;

  // Kurze Verzögerung für besseres Nutzererlebnis
  await new Promise((resolve) => setTimeout(resolve, 300));

  // Erhöhe die Seite um 1
  doneOrdersPage.value++;

  // Nach dem Laden nach unten scrollen, um die neuen Aufträge zu sehen
  nextTick(() => {
    // Finde das letzte Element vor den neu geladenen Aufträgen
    const lastVisibleIndex =
      (doneOrdersPage.value - 1) * defaultDoneOrdersLimit - 1;
    const targetElement =
      document.querySelectorAll(".order-container")[lastVisibleIndex];

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });

  loadingMoreOrders.value = false;
};

// Funktion, um zurück zur Standardansicht zu gehen
const resetDoneOrders = () => {
  doneOrdersPage.value = 1;
  showAllDoneOrders.value = false;
};

const toggleShowAllDoneOrders = async () => {
  // Wenn wir von kleiner zu voller Ansicht wechseln, zeigen wir einen Ladeindikator
  if (!showAllDoneOrders.value) {
    loadingAllOrders.value = true;
    // Kurze Verzögerung für besseres Nutzererlebnis
    await new Promise((resolve) => setTimeout(resolve, 300));
    loadingAllOrders.value = false;
  }

  showAllDoneOrders.value = !showAllDoneOrders.value;

  // Nach dem Umschalten nach unten scrollen, um den Beginn der Liste zu sehen
  if (showAllDoneOrders.value) {
    nextTick(() => {
      // Scroll zu den erledigten Aufträgen
      const completedHeader = document.querySelector(".completed-header");
      if (completedHeader) {
        completedHeader.scrollIntoView({ behavior: "smooth" });
      }
    });
  }
};

// ======== Hilfsfunktionen ========
// Neue Hilfsfunktion zur Validierung der Auftragsnummer
const isValidOrderNumber = (orderNumber) => {
  // Prüft, ob die Auftragsnummer zwischen 7 und 10 Stellen hat und nur aus Zahlen besteht
  return /^\d{7,10}$/.test(orderNumber);
};

// Formatieren des Datums: DD.MM.YYYY HH:MM
function formatDate(date) {
  if (!date) return "";

  // Ein neues Date-Objekt erstellen, damit die Originaldaten nicht verändert werden
  const localDate = new Date(date);

  const dd = String(localDate.getDate()).padStart(2, "0");
  const mm = String(localDate.getMonth() + 1).padStart(2, "0");
  const yyyy = localDate.getFullYear();
  const hh = String(localDate.getHours()).padStart(2, "0");
  const min = String(localDate.getMinutes()).padStart(2, "0");

  return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
}

// Kürzen von zu langen Texten für die Anzeige
function shortenText(text) {
  if (!text) return "";
  const maxLength = isMobile.value ? 10 : 25;
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
}

// Funktion zur Bestimmung der Zeilenklasse anhand des Status
const rowClass = (status) => {
  if (!status) return "status-offen";
  switch (status.toLowerCase()) {
    case "wartend":
      return "status-wartend";
    case "erledigt":
      return "status-erledigt";
    case "nicht vorhanden":
      return "status-nicht-vorhanden";
    case "offen":
    default:
      return "status-offen";
  }
};

// Status-basierte Farben für Chips und Akzente
const getStatusColor = (status) => {
  if (!status) return "info";
  switch (status.toLowerCase()) {
    case "wartend":
      return "amber";
    case "erledigt":
      return "success";
    case "nicht vorhanden":
      return "error";
    case "offen":
    default:
      return "info";
  }
};

// Ein- und Ausklappen von Aufträgen
const toggleOrderExpand = (orderId) => {
  if (expandedOrders.value.has(orderId)) {
    expandedOrders.value.delete(orderId);
  } else {
    expandedOrders.value.add(orderId);
  }
};

// ======== Ersatzteil-Verwaltung ========
// Ersatzteil zum Auftrag hinzufügen
const addPartItem = () => {
  advancedRequest.value.items.push({
    ersatzteil: "",
    lagerort: "",
    stueckzahl: "1",
    sonstiges: "",
  });
};

// Ersatzteil aus Auftrag entfernen
const removePartItem = (index) => {
  if (advancedRequest.value.items.length > 1) {
    advancedRequest.value.items.splice(index, 1);
  }
};

// Ersatzteil zum Auftrag bei der Bearbeitung hinzufügen
const addOrderPartItem = () => {
  orderToEdit.value.items.push({
    ersatzteil: "",
    lagerort: "",
    stueckzahl: "1",
    sonstiges: "",
  });
};

// Ersatzteil aus Auftrag bei der Bearbeitung entfernen
const removeOrderPartItem = (index) => {
  if (orderToEdit.value.items.length > 1) {
    orderToEdit.value.items.splice(index, 1);
  }
};

// Funktionen für Kommentaranzeige
const hasComments = (order) => {
  if (!order.items) return false;
  return order.items.some(
    (item) => item.commission_comment && item.commission_comment.trim() !== ""
  );
};

const countComments = (order) => {
  if (!order.items) return 0;
  return order.items.filter(
    (item) => item.commission_comment && item.commission_comment.trim() !== ""
  ).length;
};

const getItemsWithComments = (order) => {
  if (!order.items) return [];
  return order.items.filter(
    (item) => item.commission_comment && item.commission_comment.trim() !== ""
  );
};

// ======== API-Interaktionen ========
// Alle Anfragen abrufen
const fetchRequests = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}requests_commissions.php`, {
      withCredentials: true,
      params: { my_requests: 1 }, // Parameter hinzufügen, um nur eigene Anfragen zu erhalten
    });
    if (res.data.status === "success") {
      requests.value = res.data.requests;
    }
  } catch (error) {
    toast.error("Fehler beim Laden der Anfragen");
    console.error("Fehler beim Laden der Anfragen:", error);
  }
};

// Einfache Anfrage senden
const submitRequest = async () => {
  if (!isFormValid.value) {
    toast.error("Bitte alle Pflichtfelder ausfüllen");
    return;
  }

  submitting.value = true;
  try {
    const response = await axios.post(
      `${API_BASE_URL}requests_commissions.php`,
      {
        action: "add_simple",
        ersatzteil: ersatzteil.value.trim(),
        lagerort: lagerort.value.trim(),
        stueckzahl: stueckzahl.value,
        sonstiges: sonstiges.value.trim() || "",
      },
      { withCredentials: true }
    );

    if (response.data.status === "success") {
      toast.success("Anfrage erfolgreich gesendet");
      resetSimpleForm();
      await fetchRequests();
      await broadcastUpdate();
    } else {
      toast.error(response.data.message || "Fehler beim Senden der Anfrage");
    }
  } catch (error) {
    console.error("Fehler beim Absenden:", error);
    toast.error("Fehler beim Senden der Anfrage");
  } finally {
    submitting.value = false;
  }
};

// Füge diese Funktion zu deinem setup hinzu
const getStatusCount = (order, status) => {
  if (!order.items) return 0;
  return order.items.filter(
    (item) => item.status.toLowerCase() === status.toLowerCase()
  ).length;
};

// Erweiterte Anfrage mit mehreren Ersatzteilen senden
const submitAdvancedRequest = async () => {
  if (!isAdvancedFormValid.value) {
    toast.error("Bitte alle Pflichtfelder ausfüllen");
    return;
  }

  submitting.value = true;
  try {
    const response = await axios.post(
      `${API_BASE_URL}requests_commissions.php`,
      {
        action: "add_order",
        order_number: advancedRequest.value.orderNumber.trim(),
        items: advancedRequest.value.items.map((item) => ({
          ersatzteil: item.ersatzteil.trim(),
          lagerort: item.lagerort.trim(),
          stueckzahl: item.stueckzahl,
          sonstiges: item.sonstiges?.trim() || "",
        })),
      },
      { withCredentials: true }
    );

    if (response.data.status === "success") {
      toast.success("Auftrag erfolgreich erstellt");
      resetAdvancedForm();
      await fetchRequests();
      await broadcastUpdate();
    } else {
      toast.error(
        response.data.message || "Fehler beim Erstellen des Auftrags"
      );
    }
  } catch (error) {
    console.error("Fehler beim Absenden:", error);
    toast.error("Fehler beim Erstellen des Auftrags");
  } finally {
    submitting.value = false;
  }
};

// Formulare zurücksetzen
const resetSimpleForm = () => {
  ersatzteil.value = "";
  lagerort.value = "";
  stueckzahl.value = "1";
  sonstiges.value = "";
  currentDateTime.value = formatDate(new Date());
};

const resetAdvancedForm = () => {
  advancedRequest.value = {
    orderNumber: "",
    items: [
      {
        ersatzteil: "",
        lagerort: "",
        stueckzahl: "1",
        sonstiges: "",
      },
    ],
  };
  currentDateTime.value = formatDate(new Date());
};

// Ersatzteil zum Bearbeiten öffnen
const editItem = (item, order) => {
  itemToEdit.value = { ...item };
  parentOrderOfItem.value = order;
  editItemDialog.value = true;
};

// Ersatzteil aktualisieren
const updateItem = async () => {
  if (!isEditItemFormValid.value) {
    toast.error("Bitte alle Pflichtfelder ausfüllen");
    return;
  }

  updating.value = true;
  try {
    const response = await axios.post(
      `${API_BASE_URL}requests_commissions.php`,
      {
        action: "update_item",
        id: itemToEdit.value.id,
        ersatzteil: itemToEdit.value.ersatzteil.trim(),
        lagerort: itemToEdit.value.lagerort.trim(),
        stueckzahl: itemToEdit.value.stueckzahl,
        sonstiges: itemToEdit.value.sonstiges?.trim() || "",
      },
      { withCredentials: true }
    );

    if (response.data.status === "success") {
      toast.success("Ersatzteil aktualisiert");
      editItemDialog.value = false;
      await fetchRequests();
      await broadcastUpdate();
    } else {
      toast.error(
        response.data.message || "Fehler beim Aktualisieren des Ersatzteils"
      );
    }
  } catch (error) {
    console.error("Fehler beim Aktualisieren:", error);
    toast.error("Fehler beim Aktualisieren des Ersatzteils");
  } finally {
    updating.value = false;
  }
};

// Auftrag zum Bearbeiten öffnen
const editOrder = (order) => {
  orderToEdit.value = JSON.parse(JSON.stringify(order)); // Deep clone
  editOrderDialog.value = true;
};

// Auftrag aktualisieren
const updateOrder = async () => {
  if (!isEditOrderFormValid.value) {
    toast.error("Bitte alle Pflichtfelder ausfüllen");
    return;
  }

  updating.value = true;
  try {
    const response = await axios.post(
      `${API_BASE_URL}requests_commissions.php`,
      {
        action: "update_order",
        id: orderToEdit.value.id,
        order_number: orderToEdit.value.order_number.trim(),
        items: orderToEdit.value.items.map((item) => ({
          ersatzteil: item.ersatzteil.trim(),
          lagerort: item.lagerort.trim(),
          stueckzahl: item.stueckzahl,
          sonstiges: item.sonstiges?.trim() || "",
        })),
      },
      { withCredentials: true }
    );

    if (response.data.status === "success") {
      toast.success("Auftrag aktualisiert");
      editOrderDialog.value = false;
      await fetchRequests();
      await broadcastUpdate();
    } else{
      toast.error(
        response.data.message || "Fehler beim Aktualisieren des Auftrags"
      );
    }
  } catch (error) {
    console.error("Fehler beim Aktualisieren:", error);
    toast.error("Fehler beim Aktualisieren des Auftrags");
  } finally {
    updating.value = false;
  }
};

// Dialog zum Löschen öffnen
const confirmDeleteOrder = (id) => {
  orderToDeleteId.value = id;
  deleteOrderDialog.value = true;
};

// Neue Funktion zum Laden aller erledigten Aufträge
const loadAllDoneOrders = () => {
  showAllDoneOrders.value = true;
  loadingMoreOrders.value = true;

  // Warte kurz, um den Ladezustand anzuzeigen
  window.setTimeout(() => {
    loadingMoreOrders.value = false;
  }, 500);
};

// Auftrag löschen
const deleteOrder = async () => {
  deleting.value = true;
  try {
    const response = await axios.post(
      `${API_BASE_URL}requests_commissions.php`,
      {
        action: "delete_order",
        id: orderToDeleteId.value,
      },
      { withCredentials: true }
    );

    if (response.data.status === "success") {
      toast.success("Auftrag erfolgreich gelöscht");
      deleteOrderDialog.value = false;
      await fetchRequests();
      await broadcastUpdate();
    } else {
      toast.error(response.data.message || "Fehler beim Löschen des Auftrags");
    }
  } catch (error) {
    console.error("Fehler beim Löschen:", error);
    toast.error("Fehler beim Löschen des Auftrags");
  } finally {
    deleting.value = false;
  }
};

// ======== WebSocket-Integration ========
// Handler für Request-Updates
const handleRequestUpdate = (data) => {
  fetchRequests();
};

// WebSocket-Verbindung einrichten - nutzt zentrale Verbindung
const setupWebSocket = async () => {
  try {
    const WebSocketService = (await import('@/services/WebSocketService')).default;

    // Stelle sicher, dass WebSocket verbunden ist
    WebSocketService.connect();

    // Handler für Request-Updates registrieren
    WebSocketService.addMessageHandler('request_update', handleRequestUpdate);
    WebSocketService.addMessageHandler('update', handleRequestUpdate);
  } catch (error) {
    console.error("Fehler beim Einrichten des WebSocket-Handlers:", error);
  }
};

// WebSocket-Update an alle Clients broadcasten
const broadcastUpdate = async () => {
  try {
    const WebSocketService = (await import('@/services/WebSocketService')).default;

    // Warte kurz, falls WebSocket gerade connected
    if (!WebSocketService.isConnected.value) {
      // Versuche nochmal connect
      WebSocketService.connect();
      // Warte bis zu 2 Sekunden
      for (let i = 0; i < 20; i++) {
        if (WebSocketService.isConnected.value) break;
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }

    if (WebSocketService.isConnected.value) {
      // Sende einfaches "update" das der Server an alle weiterleitet
      WebSocketService.send("update");
    }
  } catch (error) {
    console.error("Fehler beim Broadcasting des Updates:", error);
  }
};

// Handler aufräumen
const cleanupWebSocketHandlers = () => {
  import('@/services/WebSocketService').then(({ default: WebSocketService }) => {
    WebSocketService.removeMessageHandler('request_update', handleRequestUpdate);
    WebSocketService.removeMessageHandler('update', handleRequestUpdate);
  });
};

// Automatische Aktualisierung des Datums alle 60 Sekunden
const dateUpdateInterval = setInterval(() => {
  currentDateTime.value = formatDate(new Date());
}, 60000);

onBeforeUnmount(() => {
  clearInterval(dateUpdateInterval);
});

// ======== Komponenten-Lifecycle ========
onMounted(() => {
  fetchRequests();
  setupWebSocket();
});

onBeforeUnmount(() => {
  cleanupWebSocketHandlers();
});
</script>

<style scoped>
/* ======== Grundlayout und Container ======== */
/* Container mit konsistenter Breite */
.app-container {
  max-width: 1200px !important;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 32px;
}

.request-view {
  position: relative;
  width: 100%;
}

.request-card {
  background: rgba(25, 25, 30, 0.85) !important;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* ======== Tab-Navigation ======== */
.card-tabs {
  background: rgba(20, 20, 25, 0.4);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.tab-item {
  letter-spacing: 0.5px;
  font-weight: 500;
}

/* ======== Header-Bereiche ======== */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.active-header {
  background: linear-gradient(
    90deg,
    rgba(255, 193, 7, 0.2),
    rgba(255, 193, 7, 0.1),
    transparent
  );
}

.completed-header {
  background: linear-gradient(
    90deg,
    rgba(76, 175, 80, 0.2),
    rgba(76, 175, 80, 0.1),
    transparent
  );
}

.title-container {
  display: flex;
  align-items: center;
}

.card-title {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  letter-spacing: 0.3px;
  background: linear-gradient(45deg, #ffffff, rgba(255, 255, 255, 0.8));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-counter {
  font-weight: bold;
  padding: 0 8px;
}

.card-divider {
  border-color: rgba(255, 255, 255, 0.06);
  margin: 0;
}

/* ======== Inhaltsbereiche ======== */
.card-content {
  padding: 20px;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
}

/* ======== Formularelemente ======== */
.form-field {
  margin-bottom: 12px;
}

.form-field :deep(.v-field__input) {
  color: rgba(255, 255, 255, 0.85);
}

.form-field :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.12);
}

.form-field:hover :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.18);
}

.submit-btn {
  height: 44px;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.25) !important;
  letter-spacing: 0.5px;
  border-radius: 10px !important;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(76, 175, 80, 0.35) !important;
}

/* ======== Ersatzteil-Liste im Formular ======== */
.parts-list {
  margin-top: 20px;
  background: rgba(30, 30, 40, 0.3);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.parts-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 16px 0;
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
}

.part-item {
  margin-bottom: 16px;
  background: rgba(25, 25, 30, 0.5);
  border-radius: 10px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  position: relative;
  transition: all 0.3s ease;
}

.part-item:hover {
  background: rgba(25, 25, 30, 0.7);
  border-color: rgba(255, 255, 255, 0.08);
  transform: translateY(-2px);
}

.part-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.part-number {
  font-size: 14px;
  font-weight: 500;
  color: rgba(76, 175, 80, 0.9);
  letter-spacing: 0.5px;
}

.item-divider {
  margin: 16px 0;
  opacity: 0.4;
}

.add-part-actions {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.add-part-btn {
  width: 100%;
  max-width: 300px;
  transition: all 0.3s ease;
}

.add-part-btn:hover {
  transform: translateY(-2px);
}

/* ======== Auftrags-Listendarstellung ======== */
.order-list {
  padding: 0 16px 16px 16px;
}

.order-container {
  margin-bottom: 10px;
  background: rgba(30, 30, 40, 0.4);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.order-container:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: rgba(25, 25, 30, 0.7);
  cursor: pointer;
  transition: background 0.2s ease;
}

.order-header:hover {
  background: rgba(76, 175, 80, 0.1);
}

.order-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-number {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
}

.order-date {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

.order-status {
  display: flex;
  align-items: center;
  gap: 12px;
}

.expand-icon {
  font-size: 22px;
  transition: transform 0.3s ease;
}

.rotate-icon {
  transform: rotate(180deg);
}

/* ======== Ersatzteil-Tabelle innerhalb des Auftrags ======== */
.order-items-container {
  padding: 0 16px 16px;
  animation: slideDown 0.3s ease-out forwards;
  overflow: hidden;
}

@keyframes slideDown {
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 2000px;
    opacity: 1;
  }
}

.items-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 14px;
}

.items-table th {
  text-align: left;
  padding: 12px;
  background: rgba(20, 20, 25, 0.6);
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  letter-spacing: 0.3px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 13px;
}

.items-table td {
  padding: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
}

.items-table tr:hover td {
  background: rgba(35, 35, 45, 0.5);
}

/* ======== Mobile Anpassungen für Auftragsansicht ======== */
.order-mobile-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.order-id-mobile {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
}

.order-date-mobile {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
}

.order-status-mobile {
  display: flex;
  align-items: center;
  gap: 8px;
}

.expand-icon-mobile {
  transition: transform 0.3s ease;
  font-size: 18px !important;
}

.order-items-mobile {
  padding: 12px;
  background: rgba(20, 20, 25, 0.3);
  animation: slideDown 0.3s ease-out forwards !important;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.item-card-mobile {
  background: rgba(30, 30, 40, 0.5) !important;
  border-radius: 8px !important;
  margin-bottom: 10px !important;
  overflow: hidden !important;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.item-card-mobile:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.item-card-content {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item-info-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.item-status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.order-actions-mobile {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* ======== Bearbeitungsdialog für Aufträge ======== */
.edit-parts-list {
  margin-top: 12px;
  padding: 16px;
  background: rgba(30, 30, 40, 0.3);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.parts-title-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.edit-part-item {
  margin-bottom: 16px;
  background: rgba(25, 25, 30, 0.5);
  border-radius: 10px;
  padding: 14px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  transition: all 0.3s ease;
}

.edit-part-item:last-child {
  margin-bottom: 0;
}

.edit-part-item:hover {
  background: rgba(25, 25, 30, 0.7);
  border-color: rgba(255, 255, 255, 0.08);
  transform: translateY(-2px);
}

/* ======== Dialog-Styling ======== */
.request-dialog :deep(.v-card),
.confirm-dialog :deep(.v-card) {
  background: rgba(25, 25, 30, 0.9) !important;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.dialog-header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(
    90deg,
    rgba(76, 175, 80, 0.2),
    rgba(76, 175, 80, 0.1),
    transparent
  );
}

.error-header {
  background: linear-gradient(
    90deg,
    rgba(244, 67, 54, 0.2),
    rgba(244, 67, 54, 0.1),
    transparent
  );
}

.dialog-content {
  padding: 20px;
  color: rgba(255, 255, 255, 0.8);
}

.dialog-actions {
  display: flex;
  padding: 12px 20px;
}

/* ======== Tabellen ======== */
.table-container {
  position: relative;
  overflow-x: auto;
  width: 100%;
}

.truncate-text {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  cursor: default;
}

/* Status-Chip */
.status-chip {
  font-size: 12px;
  font-weight: 500;
}

.status-chip-mobile {
  font-size: 10px !important;
  height: 20px !important;
  font-weight: 500 !important;
  padding: 0 8px !important;
}

/* Actions Column */
.actions-column {
  width: 100px;
  text-align: center;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  opacity: 0.7;
  transition: all 0.2s ease;
}

.action-btn:hover {
  opacity: 1;
  transform: scale(1.1);
}

.action-btn-mobile {
  opacity: 0.85;
  transition: all 0.2s ease;
}

.action-btn-mobile:hover {
  opacity: 1;
  transform: translateY(-2px);
}

/* Status-Klassen für die Tabellen */
.status-offen {
  background: rgba(33, 150, 243, 0.1);
}

.status-wartend {
  background: rgba(255, 193, 7, 0.1);
}

.status-erledigt {
  background: rgba(76, 175, 80, 0.1);
}

.status-nicht-vorhanden {
  background: rgba(244, 67, 54, 0.1);
}

/* ======== Mobile Kartenansicht ======== */
.mobile-orders {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px 16px 16px;
}

.order-card-mobile {
  background: rgba(30, 30, 40, 0.4);
  border-radius: 12px;
  overflow: hidden;
  border-left: 3px solid rgba(76, 175, 80, 0.6);
  transition: all 0.3s ease;
}

.order-card-mobile:hover {
  transform: translateX(3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.order-card-mobile.status-offen {
  border-left-color: rgba(33, 150, 243, 0.6);
}

.order-card-mobile.status-wartend {
  border-left-color: rgba(255, 193, 7, 0.6);
}

.order-card-mobile.status-erledigt {
  border-left-color: rgba(76, 175, 80, 0.6);
}

.order-card-mobile.status-nicht-vorhanden {
  border-left-color: rgba(244, 67, 54, 0.6);
}

.order-card-mobile.completed {
  opacity: 0.85;
}

.order-card-header {
  padding: 10px 12px !important;
  align-items: center !important;
  background: rgba(25, 25, 30, 0.6) !important;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.info-label {
  font-weight: 500;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  min-width: 80px;
}

.info-value {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
}

/* ======== Status-Übersicht und Kommentare ======== */
/* Für die Status-Übersicht im Desktop-Modus */
.status-overview {
  display: flex;
  align-items: center;
}

.status-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.status-pill {
  height: 18px !important;
  font-size: 10px !important;
  font-weight: 500 !important;
}

/* Für die Status-Übersicht im Mobile-Modus */
.status-overview-mobile {
  display: flex !important;
  margin-top: 4px !important;
  gap: 4px !important;
}

.status-pill-mobile {
  height: 16px !important;
  min-width: 16px !important;
  font-size: 10px !important;
  padding: 0 6px !important;
  margin-right: 3px !important;
}

/* Position-Counter wie in CommissionView */
.position-counter {
  height: 18px !important;
  font-size: 10px !important;
}

.position-counter-mobile {
  height: 16px !important;
  min-width: 16px !important;
  font-size: 9px !important;
  padding: 0 4px !important;
  margin-left: 4px !important;
}

/* Kommentar-Anzeige Styles */
.comments-indicator {
  display: flex;
  align-items: center;
}

.comment-pill {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 193, 7, 0.15);
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 11px;
  color: rgba(255, 193, 7, 0.9);
  cursor: help;
}

.comments-indicator-mobile {
  margin-top: 3px !important;
  display: flex !important;
  align-items: center !important;
}

.comment-pill-mobile {
  height: 16px !important;
  font-size: 10px !important;
  cursor: help !important;
}

.tooltip-content {
  max-width: 300px;
}

.tooltip-comment {
  padding: 4px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.tooltip-comment:last-child {
  border-bottom: none;
}

/* Hinweis für weitere erledigte Aufträge */
.more-orders-info {
  text-align: center;
  padding: 12px;
  margin-top: 10px;
  background: rgba(76, 175, 80, 0.05);
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  border: 1px dashed rgba(76, 175, 80, 0.3);
}

.more-orders-info-mobile {
  text-align: center;
  padding: 10px;
  margin-top: 10px;
  background: rgba(76, 175, 80, 0.05);
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  border: 1px dashed rgba(76, 175, 80, 0.3);
}

/* ======== Animationen ======== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.order-container,
.order-card-mobile {
  animation: fadeIn 0.3s ease-out;
}

/* ======== Responsive Design ======== */
@media (max-width: 960px) {
  .card-content {
    padding: 16px;
  }

  .items-table th,
  .items-table td {
    padding: 10px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 6px;
  }

  .actions-column {
    width: 60px;
  }

  .truncate-text {
    max-width: 120px;
  }

  .part-item {
    padding: 12px;
  }

  .parts-list {
    padding: 12px;
  }
}

@media (max-width: 600px) {
  .card-header {
    padding: 14px 16px;
  }

  .card-title {
    font-size: 16px;
  }

  .card-content {
    padding: 12px;
  }

  .desktop-table {
    display: none;
  }

  .order-card-mobile {
    position: relative;
  }

  .info-label {
    min-width: 70px;
  }

  .parts-title {
    font-size: 15px;
  }

  .part-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .edit-parts-list {
    padding: 12px;
  }
}
/* Ergänze am Ende des CSS-Codes */
.show-all-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  margin-top: 8px;
}

.show-all-btn {
  min-width: 220px;
  transition: all 0.3s ease;
}

.show-all-btn:hover {
  transform: translateY(-2px);
}

.text-caption {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
}

.show-more-btn,
.show-all-btn {
  min-width: 220px;
  transition: all 0.3s ease;
}

.show-more-btn:hover,
.show-all-btn:hover {
  transform: translateY(-2px);
}

.show-less-container {
  display: flex;
  justify-content: center;
  margin-top: 8px;
  padding-top: 8px;
}

.show-less-btn {
  opacity: 0.7;
  transition: all 0.3s ease;
}

.show-less-btn:hover {
  opacity: 1;
  transform: translateY(-2px);
}
</style>
